import { CardCreditPipe } from './../pipe-card-credit/card-credit.pipe';
import { TruncatePipe } from './../pipe-truncate/truncate.pipe';
import { TelefonePipe } from './../pipe-telefone/telefone.pipe';
import { CnpjPipe } from '../pipe-cnpj/cnpj.pipe';
import {
    Pipe,
    PipeTransform
} from '@angular/core';

// Library used to humanize a date in this example
import { DatePipe, CurrencyPipe, DecimalPipe, UpperCasePipe, TitleCasePipe } from '@angular/common';
import { CpfPipe } from '../pipe-cpf/cpf.pipe';
import { CepPipe } from '../pipe-cep/cep.pipe';


@Pipe({name: 'dynamic'})
export class DynamicPipe implements PipeTransform {



    transform(value:string | number, modifier:string) {
        if (!modifier) { return value; }

        if(value !== null && value !== undefined ){
          if (typeof value == 'number') {
            value = value.toString()
          }
          return eval('this.' + modifier + '(\'' + value + '\')');
        }
        return value;

    }

    statusFromBoolean(value:string):string {
        switch (value) {
            case 'true':
            case '1':
                return 'Sim';
            default:
                return 'Não';
        }
    }

    fullDateTimeIso(value:string, modifier?:string) {
      return new DatePipe('pt-br').transform(value, 'yyyy-MM-ddTHH:mm' );

    }
    fullDateTime(value:string, modifier?:string) {
        return new DatePipe('pt-br').transform(value, 'dd/MM/yyyy  HH:mm' );
    }
    fullDate(value:string, modifier?:string) {
      return new DatePipe('pt-br').transform(value, 'dd/MM/yyyy' );
    }
    fullDateView(value:string, modifier?:string) {
      return new DatePipe('pt-br').transform(value, 'ccc dd MMMM yyyy' );
    }
    day(value:string, modifier:string) {
      return new DatePipe('pt-br').transform(value, 'dd' );
    }

    month(value:string, modifier:string) {
      return new DatePipe('pt-br').transform(value, 'MMM' );
    }

    time(value:string, modifier:string) {
      return new DatePipe('pt-br').transform(value, 'HH:mm' );
    }

    title(value: any){
      return new TitleCasePipe().transform(value);
    }

    cnpj(value: string) {
        return new CnpjPipe().transform(value);
    }

    cep(value: string){
        return new CepPipe().transform(value);
    }

    currency(value: string){
      return new CurrencyPipe('pt_BR').transform(value, 'BRL');

    }

    decimal(value: string){
      return new DecimalPipe('pt-br').transform(value, '1.0-2');
    }

    phone(value: string){
      return new TelefonePipe().transform(value );
    }

    cpf(value: string) {
      return new CpfPipe().transform(value);
    }

    truncate(value: string, args: string[]){

      return new TruncatePipe().transform( value, args );
    }
    card_credit(value: string){
      const  args: string[] = ['************', '4']
      return new CardCreditPipe().transform( value, args );
    }

    numPedido(value: string){
      //@ts-ignore
      return new DecimalPipe('pt-br').transform(value, '6.0-0' ).replace(/[. ]/gi, '');
    }

    // truncateTable(value: string){
    //   return new TruncatePipe().transform( value, ['50'] );
    // }

    uppercase(value: string, args: string[]){
      return new UpperCasePipe().transform( value);
    }
    address(value: any, args?: string[]){
      let foo = `${value.street}, ${value.street_number} ${value.complementary? value.complementary + ', ':''}${value.neighborhood} (${value.zipcode.slice(0, 5) + '-'+ value.zipcode.slice(5, value.zipcode.length) }) ${value.city}/${value.state} ${value.reference? '- '+ value.reference : ''}`;
      return foo;
    }





}

export const DYNAMIC_PIPES = [DynamicPipe];
